export enum LoginErrorEnum {
    CONCURRENT_SESSION = 'È stato rilevato una sessione attiva su un altro dispositivo. Tutte le sessioni sono state terminate.',
    GENERIC_ERROR = 'Si è verificato un errore durante il processo di autenticazione tramite SSO.',
    EXCHANGE_TOKEN = 'Errore nello scambio dei token, codice errore: '
}
